import { Component, Input } from '@angular/core';
import { HeatTraceTest } from '../models/heat-trace';

@Component({
  selector: 'app-pipe-test',
  templateUrl: './pipe-test.component.html',
  styleUrls: ['./pipe-test.component.scss'],
  standalone: false,
})
export class PipeTestComponent {
  @Input() testData: HeatTraceTest;

  private rankToColor(rank?: number): string {
    switch (rank) {
      case 4:
        return 'red';
      case 3:
      case 2:
        return 'orange';
      case 1:
        return 'green';
      default:
        return 'lightgray';
    }
  }

  get leftStatusColor(): string {
    // Keep CP as the primary signal on the left bar; fallback to MC.
    return this.rankToColor(this.testData?.cpStatus?.rank ?? this.testData?.mcStatus?.rank);
  }
}
